module.exports = __webpack_public_path__ + "img/tamiltoken-friend-referral.cf57a622.jpg";